import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 配置axios
const apiBaseURL = process.env.VUE_APP_API_BASE_URL || 'https://api.ihanzi.net/v1/mose/api'
axios.defaults.baseURL = apiBaseURL
axios.defaults.timeout = 600000 

// 强制输出配置信息（用于调试）
console.log('=== API 配置信息 ===')
console.log('环境变量 VUE_APP_API_BASE_URL:', process.env.VUE_APP_API_BASE_URL)
console.log('最终使用的 API Base URL:', apiBaseURL)
console.log('Axios baseURL:', axios.defaults.baseURL)
console.log('==================')

Vue.prototype.$http = axios

new Vue({
  render: h => h(App),
}).$mount('#app')

